export default __webpack_public_path__ + "static/cabin-basic-new-1-1d750aa574f1ee99d6d3a4e295611024.jpg";